/*
 * LoaderComponent
 *
 * Loader component is common for all the pages for showing loading indecator
 *
 */

import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import '../css/loader.css';
import SpinnerComponent from './SpinnerComponent';

export default class LoaderComponent extends Component {
	render() {
		return (
			<Modal show={this.props.show} backdrop="static"
				keyboard={false} contentClassName="loader-modal-size" backdropClassName={this.props.backdropClassName} centered="true">
				<Modal.Header className="beck-modal-header">
					<Modal.Title className="beck-modal-title">{ this.props.message || "Busy" }</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<div className="text-center vertical-middle">
						<SpinnerComponent />
					</div>
				</Modal.Body>
			</Modal>
		);
	}
}